
export default {
  citySelector: {
    country: 'Country',
    state: 'State',
    city: 'City',
    places: {
      countries: {
        albania: 'Albania',
        andorra: 'Andorra',
        austria: 'Austria',
        belgium: 'Belgium',
        'bosnia-and-herzegovina': 'Bosnia and Herzegovina',
        bulgaria: 'Bulgaria',
        croatia: 'Croatia',
        cyprus: 'Cyprus',
        czechia: 'Czechia',
        denmark: 'Denmark',
        estonia: 'Estonia',
        finland: 'Finland',
        france: 'France',
        germany: 'Germany',
        greece: 'Greece',
        hungary: 'Hungary',
        iceland: 'Iceland',
        ireland: 'Ireland',
        italy: 'Italy',
        kosovo: 'Kosovo',
        latvia: 'Latvia',
        liechtenstein: 'Liechtenstein',
        lithuania: 'Lithuania',
        luxembourg: 'Luxembourg',
        malta: 'Malta',
        moldova: 'Moldova',
        monaco: 'Monaco',
        montenegro: 'Montenegro',
        netherlands: 'Netherlands',
        'north-macedonia': 'North Macedonia',
        norway: 'Norway',
        poland: 'Poland',
        portugal: 'Portugal',
        romania: 'Romania',
        'san-marino': 'San Marino',
        serbia: 'Serbia',
        slovakia: 'Slovakia',
        slovenia: 'Slovenia',
        spain: 'Spain',
        sweden: 'Sweden',
        switzerland: 'Switzerland',
        turkey: 'Turkey',
        ukraine: 'Ukraine',
        'united-kingdom': 'United Kingdom'
      },
      states: {
        'baden-wuerttemberg': 'Baden-Württemberg',
        bayern: 'Bavaria',
        berlin: 'Berlin',
        bremen: 'Bremen',
        brandenburg: 'Brandenburg',
        hamburg: 'Hamburg',
        hessen: 'Hesse',
        'mecklenburg-vorpommern': 'Mecklenburg-Vorpommern',
        niedersachsen: 'Lower Saxony',
        'nordrhein-westfalen': 'North Rhine-Westphalia',
        'rheinland-pfalz': 'Rhineland-Palatinate',
        saarland: 'Saarland',
        sachsen: 'Saxony',
        'sachsen-anhalt': 'Saxony-Anhalt',
        'schleswig-holstein': 'Schleswig-Holstein',
        thueringen: 'Thuringia',
        wien: 'Vienna',
        oberoesterreich: 'Upper Austria',
        salzburg: 'Salzburg',
        steiermark: 'Styria',
        tirol: 'Tyrol'
      },
      // Only cities whose anglicized name differs from the slug-derived
      // fallback (prepareString) need an entry here.
      cities: {
        'andorra-la-vella': 'Andorra la Vella',
        koeln: 'Cologne',
        hannover: 'Hanover',
        moers: 'Moers',
        muenchen: 'Munich',
        nuernberg: 'Nuremberg',
        prague: 'Prague',
        'san-marino': 'San Marino',
        wien: 'Vienna'
      }
    }
  }
}
